"use client";

import { Button } from "@workspace/frontend-ui";
import LinkComponent from "@workspace/nextjs_utils/src/components/LinkComponent";
import { useSelectedLayoutSegments } from "next/navigation";
import type { FC } from "react";
import isGamePageRoute from "./isGamePageRoute";

type Props = {
  loginHref: string;
  registerHref: string;
  loginLabel: string;
  registerLabel: string;
  isRegistrationDisabled?: boolean;
};

const handleAuthRequest = (tab: "login" | "register") => () => {
  window.dispatchEvent(
    new CustomEvent("gamePageAuthRequest", { detail: { tab } }),
  );
};

// The Header is a layout sibling of the game page, not a parent, so it signals over a window event.
const LoggedOutControls: FC<Props> = ({
  loginHref,
  registerHref,
  loginLabel,
  registerLabel,
  isRegistrationDisabled = false,
}) => {
  const segments = useSelectedLayoutSegments();

  if (isGamePageRoute(segments)) {
    return (
      <div className="flex gap-1.5">
        <Button
          variant="outline"
          size="xl"
          onClick={handleAuthRequest("login")}
        >
          {loginLabel}
        </Button>
        {!isRegistrationDisabled && (
          <Button size="xl" onClick={handleAuthRequest("register")}>
            {registerLabel}
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="flex gap-1.5">
      <Button variant="outline" size="xl" asChild>
        <LinkComponent href={loginHref}>{loginLabel}</LinkComponent>
      </Button>
      {!isRegistrationDisabled && (
        <Button size="xl" asChild>
          <LinkComponent href={registerHref}>{registerLabel}</LinkComponent>
        </Button>
      )}
    </div>
  );
};

export default LoggedOutControls;
